import React from 'react'
import loaderSvg from '../../assets/images/loader.svg'

const PageLoader: React.FC = () => {
  return (
    <div className='page-loader'>
      <img src={loaderSvg} alt='Loading...'/>
    </div>
  )
}

export default PageLoader
